module.exports = {
  platform: 'voice',
  name: '+1 retry',
  node: 'add_retry',
  bg: '#FFFFFF',
  note: '',
  property: {
    type: 'default', // default, page, component
    page: '',
    component: ''
  }
}
